import * as index from './components/index.js';
import * as index$1 from './directives/index.js';
export { useColorModes } from './composables/useColorModes.js';
export { useDebouncedCallback } from './composables/useDebouncedCallback.js';
export { useIsVisible } from './composables/useIsVisible.js';
export { usePopper } from './composables/usePopper.js';
export { useUniqueId } from './composables/useUniqueId.js';
export { CAccordionPlugin } from './components/accordion/index.js';
export { CAccordion } from './components/accordion/CAccordion.js';
export { CAccordionBody } from './components/accordion/CAccordionBody.js';
export { CAccordionButton } from './components/accordion/CAccordionButton.js';
export { CAccordionHeader } from './components/accordion/CAccordionHeader.js';
export { CAccordionItem } from './components/accordion/CAccordionItem.js';
export { CAlertPlugin } from './components/alert/index.js';
export { CAlert } from './components/alert/CAlert.js';
export { CAlertHeading } from './components/alert/CAlertHeading.js';
export { CAlertLink } from './components/alert/CAlertLink.js';
export { CAvatarPlugin } from './components/avatar/index.js';
export { CAvatar } from './components/avatar/CAvatar.js';
export { CBackdropPlugin } from './components/backdrop/index.js';
export { CBackdrop } from './components/backdrop/CBackdrop.js';
export { CBadge } from './components/badge/CBadge.js';
export { CBadgePlugin } from './components/badge/index.js';
export { CBreadcrumbPlugin } from './components/breadcrumb/index.js';
export { CBreadcrumb } from './components/breadcrumb/CBreadcrumb.js';
export { CBreadcrumbItem } from './components/breadcrumb/CBreadcrumbItem.js';
export { CButtonPlugin } from './components/button/index.js';
export { CButton } from './components/button/CButton.js';
export { CButtonGroupPlugin } from './components/button-group/index.js';
export { CButtonToolbar } from './components/button-group/CButtonToolbar.js';
export { CButtonGroup } from './components/button-group/CButtonGroup.js';
export { CCalendar } from './components/calendar/CCalendar.js';
export { CCalendarPlugin } from './components/calendar/index.js';
export { CCalloutPlugin } from './components/callout/index.js';
export { CCallout } from './components/callout/CCallout.js';
export { CCardPlugin } from './components/card/index.js';
export { CCard } from './components/card/CCard.js';
export { CCardBody } from './components/card/CCardBody.js';
export { CCardFooter } from './components/card/CCardFooter.js';
export { CCardGroup } from './components/card/CCardGroup.js';
export { CCardHeader } from './components/card/CCardHeader.js';
export { CCardImage } from './components/card/CCardImage.js';
export { CCardImageOverlay } from './components/card/CCardImageOverlay.js';
export { CCardLink } from './components/card/CCardLink.js';
export { CCardSubtitle } from './components/card/CCardSubtitle.js';
export { CCardText } from './components/card/CCardText.js';
export { CCardTitle } from './components/card/CCardTitle.js';
export { CCarouselPlugin } from './components/carousel/index.js';
export { CCarousel } from './components/carousel/CCarousel.js';
export { CCarouselCaption } from './components/carousel/CCarouselCaption.js';
export { CCarouselItem } from './components/carousel/CCarouselItem.js';
export { CCloseButtonPlugin } from './components/close-button/index.js';
export { CCloseButton } from './components/close-button/CCloseButton.js';
export { CCollapsePlugin } from './components/collapse/index.js';
export { CCollapse } from './components/collapse/CCollapse.js';
export { CConditionalTeleport } from './components/conditional-teleport/CConditionalTeleport.js';
export { CConditionalTeleportPlugin } from './components/conditional-teleport/index.js';
export { CDatePickerPlugin } from './components/date-picker/index.js';
export { CDatePicker } from './components/date-picker/CDatePicker.js';
export { CDateRangePickerPlugin } from './components/date-range-picker/index.js';
export { CDateRangePicker } from './components/date-range-picker/CDateRangePicker.js';
export { CDropdownPlugin } from './components/dropdown/index.js';
export { CDropdown } from './components/dropdown/CDropdown.js';
export { CDropdownItem } from './components/dropdown/CDropdownItem.js';
export { CDropdownHeader } from './components/dropdown/CDropdownHeader.js';
export { CDropdownDivider } from './components/dropdown/CDropdownDivider.js';
export { CDropdownMenu } from './components/dropdown/CDropdownMenu.js';
export { CDropdownToggle } from './components/dropdown/CDropdownToggle.js';
export { CElementCoverPlugin } from './components/element-cover/index.js';
export { CElementCover } from './components/element-cover/CElementCover.js';
export { CFooterPlugin } from './components/footer/index.js';
export { CFooter } from './components/footer/CFooter.js';
export { CFormPlugin } from './components/form/index.js';
export { CForm } from './components/form/CForm.js';
export { CFormCheck } from './components/form/CFormCheck.js';
export { CFormFeedback } from './components/form/CFormFeedback.js';
export { CFormFloating } from './components/form/CFormFloating.js';
export { CFormInput } from './components/form/CFormInput.js';
export { CFormLabel } from './components/form/CFormLabel.js';
export { CFormRange } from './components/form/CFormRange.js';
export { CFormSelect } from './components/form/CFormSelect.js';
export { CFormSwitch } from './components/form/CFormSwitch.js';
export { CFormText } from './components/form/CFormText.js';
export { CFormTextarea } from './components/form/CFormTextarea.js';
export { CInputGroup } from './components/form/CInputGroup.js';
export { CInputGroupText } from './components/form/CInputGroupText.js';
export { CGridPlugin } from './components/grid/index.js';
export { CCol } from './components/grid/CCol.js';
export { CContainer } from './components/grid/CContainer.js';
export { CRow } from './components/grid/CRow.js';
export { CHeaderPlugin } from './components/header/index.js';
export { CHeader } from './components/header/CHeader.js';
export { CHeaderBrand } from './components/header/CHeaderBrand.js';
export { CHeaderDivider } from './components/header/CHeaderDivider.js';
export { CHeaderNav } from './components/header/CHeaderNav.js';
export { CHeaderText } from './components/header/CHeaderText.js';
export { CHeaderToggler } from './components/header/CHeaderToggler.js';
export { CImagePlugin } from './components/image/index.js';
export { CImage } from './components/image/CImage.js';
export { CCLinkPlugin } from './components/link/index.js';
export { CLink } from './components/link/CLink.js';
export { CListGroupPlugin } from './components/list-group/index.js';
export { CListGroup } from './components/list-group/CListGroup.js';
export { CListGroupItem } from './components/list-group/CListGroupItem.js';
export { CLoadingButtonPlugin } from './components/loading-button/index.js';
export { CLoadingButton } from './components/loading-button/CLoadingButton.js';
export { CModalPlugin } from './components/modal/index.js';
export { CModal } from './components/modal/CModal.js';
export { CModalBody } from './components/modal/CModalBody.js';
export { CModalFooter } from './components/modal/CModalFooter.js';
export { CModalHeader } from './components/modal/CModalHeader.js';
export { CModalTitle } from './components/modal/CModalTitle.js';
export { CMultiSelectPlugin } from './components/multi-select/index.js';
export { CMultiSelect } from './components/multi-select/CMultiSelect.js';
export { CNavPlugin } from './components/nav/index.js';
export { CNav } from './components/nav/CNav.js';
export { CNavGroup } from './components/nav/CNavGroup.js';
export { CNavGroupItems } from './components/nav/CNavGroupItems.js';
export { CNavItem } from './components/nav/CNavItem.js';
export { CNavLink } from './components/nav/CNavLink.js';
export { CNavTitle } from './components/nav/CNavTitle.js';
export { CNavbarPlugin } from './components/navbar/index.js';
export { CNavbar } from './components/navbar/CNavbar.js';
export { CNavbarBrand } from './components/navbar/CNavbarBrand.js';
export { CNavbarNav } from './components/navbar/CNavbarNav.js';
export { CNavbarText } from './components/navbar/CNavbarText.js';
export { CNavbarToggler } from './components/navbar/CNavbarToggler.js';
export { COffcanvasPlugin } from './components/offcanvas/index.js';
export { COffcanvas } from './components/offcanvas/COffcanvas.js';
export { COffcanvasBody } from './components/offcanvas/COffcanvasBody.js';
export { COffcanvasHeader } from './components/offcanvas/COffcanvasHeader.js';
export { COffcanvasTitle } from './components/offcanvas/COffcanvasTitle.js';
export { CPaginationPlugin } from './components/pagination/index.js';
export { CPagination } from './components/pagination/CPagination.js';
export { CPaginationItem } from './components/pagination/CPaginationItem.js';
export { CPicker } from './components/picker/CPicker.js';
export { CPickerPlugin } from './components/picker/index.js';
export { CPlaceholderPlugin } from './components/placeholder/index.js';
export { CPlaceholder } from './components/placeholder/CPlaceholder.js';
export { CProgressPlugin } from './components/progress/index.js';
export { CProgress } from './components/progress/CProgress.js';
export { CProgressBar } from './components/progress/CProgressBar.js';
export { CProgressStacked } from './components/progress/CProgressStacked.js';
export { CPopoverPlugin } from './components/popover/index.js';
export { CPopover } from './components/popover/CPopover.js';
export { CRating } from './components/rating/CRating.js';
export { CRatingPlugin } from './components/rating/index.js';
export { CSidebarPlugin } from './components/sidebar/index.js';
export { CSidebar } from './components/sidebar/CSidebar.js';
export { CSidebarBrand } from './components/sidebar/CSidebarBrand.js';
export { CSidebarFooter } from './components/sidebar/CSidebarFooter.js';
export { CSidebarHeader } from './components/sidebar/CSidebarHeader.js';
export { CSidebarNav } from './components/sidebar/CSidebarNav.js';
export { CSidebarToggler } from './components/sidebar/CSidebarToggler.js';
export { CSmartPaginationPlugin } from './components/smart-pagination/index.js';
export { CSmartPagination } from './components/smart-pagination/CSmartPagination.js';
export { CSmartTablePlugin } from './components/smart-table/index.js';
export { CSmartTable } from './components/smart-table/CSmartTable.js';
export { CSpinnerPlugin } from './components/spinner/index.js';
export { CSpinner } from './components/spinner/CSpinner.js';
export { CTablePlugin } from './components/table/index.js';
export { CTable } from './components/table/CTable.js';
export { CTableBody } from './components/table/CTableBody.js';
export { CTableCaption } from './components/table/CTableCaption.js';
export { CTableDataCell } from './components/table/CTableDataCell.js';
export { CTableFoot } from './components/table/CTableFoot.js';
export { CTableHead } from './components/table/CTableHead.js';
export { CTableHeaderCell } from './components/table/CTableHeaderCell.js';
export { CTableRow } from './components/table/CTableRow.js';
export { CTabsPlugin } from './components/tabs/index.js';
export { CTab } from './components/tabs/CTab.js';
export { CTabContent } from './components/tabs/CTabContent.js';
export { CTabList } from './components/tabs/CTabList.js';
export { CTabPane } from './components/tabs/CTabPane.js';
export { CTabPanel } from './components/tabs/CTabPanel.js';
export { CTabs } from './components/tabs/CTabs.js';
export { CTimePicker } from './components/time-picker/CTimePicker.js';
export { CTimePickerPlugin } from './components/time-picker/index.js';
export { CToastPlugin } from './components/toast/index.js';
export { CToast } from './components/toast/CToast.js';
export { CToastBody } from './components/toast/CToastBody.js';
export { CToastClose } from './components/toast/CToastClose.js';
export { CToaster } from './components/toast/CToaster.js';
export { CToastHeader } from './components/toast/CToastHeader.js';
export { CTooltipPlugin } from './components/tooltip/index.js';
export { CTooltip } from './components/tooltip/CTooltip.js';
export { CVirtualScroller } from './components/virtual-scroller/CVirtualScroller.js';
export { CVirtualScrollerPlugin } from './components/virtual-scroller/index.js';
export { CWidgetsStatsPlugin } from './components/widgets/index.js';
export { CWidgetStatsA } from './components/widgets/CWidgetStatsA.js';
export { CWidgetStatsB } from './components/widgets/CWidgetStatsB.js';
export { CWidgetStatsC } from './components/widgets/CWidgetStatsC.js';
export { CWidgetStatsD } from './components/widgets/CWidgetStatsD.js';
export { CWidgetStatsE } from './components/widgets/CWidgetStatsE.js';
export { CWidgetStatsF } from './components/widgets/CWidgetStatsF.js';
export { default as vcplaceholder } from './directives/v-c-placeholder.js';
export { default as vcpopover } from './directives/v-c-popover.js';
export { default as vctooltip } from './directives/v-c-tooltip.js';

const CoreuiVue = {
    install: (app) => {
        for (const key in index) {
            app.component(key, index[key]);
        }
        for (const key in index$1) {
            app.directive(index$1[key]['name'], index$1[key]);
        }
    },
};

export { CoreuiVue as default };
//# sourceMappingURL=index.js.map
